export interface WebGl2Capabilities {
  available: boolean;
  maxTextureSize: number;
}

export function detectWebGl2Capabilities(): WebGl2Capabilities {
  try {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("webgl2");
    if (!context) return { available: false, maxTextureSize: 0 };
    const maxTextureSize = Number(context.getParameter(context.MAX_TEXTURE_SIZE)) || 0;
    context.getExtension("WEBGL_lose_context")?.loseContext();
    canvas.remove();
    return { available: true, maxTextureSize };
  } catch {
    return { available: false, maxTextureSize: 0 };
  }
}
